<div class="class-select">
  <button class="back-btn" (click)="goBack()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">{{'game-mode.class-select.title' | translate}}</h2>
  <p class="picker-subtitle">{{'game-mode.class-select.subtitle' | translate}}</p>

  <div class="classes-grid">
    <div *ngFor="let cls of classes"
         class="class-card"
         (click)="selectClass(cls)">
      <img class="class-icon" src="assets/game-mode/svg/teacherClass.svg" alt="class" />
      <span class="class-name">{{cls.name}}</span>
      <span class="grade-name" *ngIf="cls.grade">{{cls.grade.name}}</span>
    </div>
  </div>
</div>
